import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) =>
  createStyles({
    courseCard: {
      margin: '20px',
      boxShadow: 'none',
      padding: '10px',
    },
    mb18: {
      marginBottom: 18,
    },
    subTabs: {
      fontSize: 14,
      fontWeight: 400,
      color: '#666',
      cursor: 'pointer',
    },
    activeTab: {
      color: '#1d7dea!important',
      position: 'relative',
      fontWeight: 600,
      cursor: 'pointer',
      '&::before': {
        content: "''",
        width: '100%',
        height: 4,
        display: 'inline-block',
        position: 'absolute',
        left: 0,
        right: 0,
        top: 24,
        background: '#1d7dea',
        borderRadius: 4,
      },
    },
    linkCTA: {
      color: '#1d7dea',
      fontSize: 14,
      cursor: 'pointer',
    },
    customFileBrowse: {
      verticalAlign: 'revert',
      marginRight: 35,
      marginTop: -13,
      display: 'inline-block',
      '& [type=file]': {
        height: 0,
        overflow: 'hidden',
        width: 0,
      },
    },
    footerBottomFixed:{
      position: 'fixed',
      bottom: 0,
      width: '100%',
      boxShadow: '0px 0px 10px rgb(0 0 0 / 10%)',
      padding: '20px',
      backgroundColor: '#fff',
      zIndex: 11,
      right: 0,
    },
      buttonGroup:{
        maxWidth: '250px',
        width: '100%',
        marginLeft: 'auto',
        textAlign: 'right',
        '& button:nth-of-type(2)':{
          marginLeft: 10,
        }
    },
      removeBtn:{
        background: '#F21D1D',
        borderRadius: 4,
        padding: '11px 32px',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        '&:hover':{
          backgroundColor: '#F21D1D',
        },
        '&:disabled': {
          opacity: 0.5,
          cursor: 'default'
        }
        },
        moveBtn:{
          background: '#1d7dea',
          borderRadius: 4,
          padding: '11px 32px',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          '&:hover':{
            backgroundColor: '#1d7dea',
          }
      },
      customDisabled:{
        cursor: 'default',
       opacity: .5,
       pointerEvents: 'none',
      },
      scrollFixedHeight: {
        "& .perfectScrollBar": {
          maxHeight: "400px",
        },
      },
  });

export { styles };
